import * as React from 'react';
import {Component} from 'react';
import {Button, Input} from '@priority-software/priority-style-react';
import keyCodes from '../../../../constants/KeyCodes';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {handleSpreadSheetPaste} from '../../../../utils/paste';
import {Operator} from '../../consts/operators';

export class TextControl extends Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        };
    }

    handleInputChange = event => {
        this.setState({value: event.target.value});
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            (this.state.value && nextProps.operator === Operator.Empty) ||
            nextProps.operator === Operator.NotEmpty
        ) {
            this.setState({value: ''});
        }
    }

    addFilterValue = event => {
        event.stopPropagation();
        const value = this.state.value.trim();
        if (value.length > 0) {
            this.props.onChange && this.props.onChange(value);
            this.setState({value: ''});
        }
    };

    onFocus = () => {
        this.props.setActive();
        window.addEventListener('keydown', this.handleKeyDown, true);
    };

    onBlur = () => {
        this.props.unsetActive();
        window.removeEventListener('keydown', this.handleKeyDown, true);
    };

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true);
    }

    handleKeyDown = e => {
        e.stopPropagation();
        switch (e.keyCode) {
            case keyCodes.ENTER:
                this.addFilterValue(e);
                break;
            case keyCodes.ESC:
                // DO we need to clode the FilterBox on ESC ???
                break;
            default:
                break;
        }
    };

    handlePaste = event => {
        return handleSpreadSheetPaste(
            event,
            this.handleInputChange,
            this.props.handleSpreadsheetValues
        );
    };

    render() {
        return (
            <React.Fragment>
                <Input
                    size="medium"
                    value={this.state.value}
                    direction="auto"
                    onChange={this.handleInputChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onPaste={this.handlePaste}
                    placeholder={this.props.placeholder}
                    autoFocus={this.props.autoFocus}
                    disabled={this.props.isDisabled}
                >
                    <div>
                        {this.state.value && (
                            <Button
                                componentClasses="add-button"
                                onFocus={this.props.setActive}
                                onBlur={this.props.unsetActive}
                                onClick={this.addFilterValue}
                                tabIndex={-1}
                            >
                                {getLocalizedText(texts.addButton)}
                            </Button>
                        )}
                    </div>
                </Input>
            </React.Fragment>
        );
    }
}
